module.exports = __webpack_public_path__ + "static/media/they-might-be-lies.257b5f67.jpg";